import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[placasFormat]'
})
export class PlacasFormatDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = event.target;
    const rawValue = input.value.replace(/[^a-zA-Z0-9]/g, ''); // quitar guiones y símbolos
    const grupos = rawValue.match(/.{1,3}/g);
    const formateado = grupos ? grupos.join('-') : rawValue;

    this.control.control?.setValue(formateado, { emitEvent: false });
  }
}